// Module
var code = "<li ng-repeat=\"filter in sortFilters\" ng-class=\"{'active': filter.active}\"> <a ng-if=\"!filter.active\" rel=\"nofollow\" ng-click=\"sortFilterClick($event, filter.type)\" href=\"[[filter.url]]\">[[filter.label]]</a> <span ng-if=\"filter.active\">[[filter.label]]</span> </li> ";
// Exports
module.exports = code;